module.exports = __webpack_public_path__ + "img/appoint_confirmation.435ad681.png";